import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { User } from 'src/app/micro-services/user/models/user';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { InformationComponent } from './information/information.component';
import { UserCoach } from 'src/app/micro-services/user/models/user-coach';
import { ContactComponent } from './contact/contact.component';
import { AboutComponent } from './about/about.component';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent implements OnInit {

  coach : UserCoach;

  constructor(
    private userService         : UserService,
    private router              : Router,
    private readonly apiProvider: ApiProviderService,
    private readonly modalCtrl  : ModalController
  ) { }

  ngOnInit() {
    this.coach = this.userService.getUser() as UserCoach;
  }

  souscriptionClick(){
    this.router.navigateByUrl("/coach/subscribe");
  }

  backClick() {
    this.router.navigateByUrl("/coach/dashboard");
  }

  payments(){
    this.apiProvider.stripePortal().subscribe({
      next : (res) => {
        window.location.href = res.url;
      },
      error : (err) => {
      }
    })
  }

  async info(){
    let modal = await this.modalCtrl.create({
      component: InformationComponent,
      componentProps : {
        coach : this.coach
      }
    });

    await modal.present();

    const { data, role } = await modal.onDidDismiss();

    if(data && role == "confirm"){
      this.userService.setUser(data, [data.discriminator]);
    }

  }

 

  async openAboutModal() {
    this.router.navigateByUrl("/coach/about");
  }

}
